/*
 * Module for the modal where you create the name of a new quick-create topic
 */

define([
  "marionette",
  "messaging/messenger",
  "modules/quickCreate/quickTopicModal/quickTopicModalView",
], function (Marionette, Messenger, QuickTopicModalView) {
  var QuickTopicModalController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "quickTopicModal";
      this.region = options.region;
    },
    show: function (topic) {
      this.view = new QuickTopicModalView.quickTopicModalView();
      this.view.on(
        "done",
        function () {
          //make sure that the name is valid
          var topicName = this.view.getTopicName();
          topic.set("intentName", topicName);
          //get error array from validation function, or undefined if there are no errors
          var error = topic.validate();
          if (error) {
            //topic name is bad
            this.view.showError(error["intentName"]);
          } else {
            //topic name is good, trigger an enter event to simulate closing a textbox, save the topic, and close the modal
            topic.trigger("enter:intentName"); //will cause the topic label to be set
            topic.saveModel({
              success: function () {
                Messenger.vent.trigger("close:modal");
              },
              error: function (model, response) {
                //show error message
                Messenger.showErrorFromResponse(response);
              },
            });
          }
        },
        this,
      );

      this.view.on(
        "cancel",
        function () {
          //delete the new topic
          topic.deleteModel();
          Messenger.vent.trigger("close:modal");
        },
        this,
      );

      this.showRegion(this.view);
    },
  });

  return QuickTopicModalController;
});
